<p-toast></p-toast>
<p-contextMenu #cm [model]="menuContextuelRequisitions"></p-contextMenu>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="grid">
	<div class="col-12" *ngIf="!rechercheDeclenchee">
		<div class="flex justify-content-between align-items-center">
			<h4 class="my-0">Mes raccourcis</h4>
			<div>
				<button pButton icon="pi pi-cog" class="p-button-rounded p-button-text"
					(click)="showShortcutDialog = true" pTooltip="Gérer les raccourcis" tooltipPosition="left">
				</button>
				<button pButton icon="pi pi-sort" class="p-button-rounded p-button-text" (click)="openReorderDialog()"
					pTooltip="Réorganiser les raccourcis" tooltipPosition="left">
				</button>
				<button pButton icon="pi pi-refresh" class="p-button-rounded p-button-text"
					(click)="confirmResetShortcuts()" pTooltip="Réinitialiser les raccourcis"
					tooltipPosition="left"></button>
			</div>
		</div>

		<!-- Compact Shortcuts Container -->
		<div class="shortcuts-container" *ngIf="shortcuts.length > 0">
			<!-- Hover trigger area - only this visible area triggers expansion -->
			<div class="shortcuts-hover-trigger">
				<!-- Visible shortcuts row -->
				<div class="shortcuts-row">
					<div *ngFor="let shortcut of visibleShortcuts" class="shortcut-card"
						[style]="{ backgroundColor: shortcut.backgroundColor, borderColor: shortcut.textColor}"
						[routerLink]="shortcut.routerLink"
						(click)="shortcut.href ? openExternalLink(shortcut.href) : null">
						<div class="shortcut-content">
							<i [class]="shortcut.icon" [style]="{ color: shortcut.textColor }"></i>
							<div class="shortcut-label">{{ shortcut.label }}</div>
						</div>
					</div>
				</div>

				<!-- Indicator for hidden shortcuts -->
				<div class="shortcuts-indicator" *ngIf="hiddenShortcuts.length > 0">
					+{{ hiddenShortcuts.length }}
				</div>
			</div>

			<!-- Hidden shortcuts (shown on hover) -->
			<div class="hidden-shortcuts" *ngIf="hiddenShortcuts.length > 0">
				<div class="shortcuts-row">
					<div *ngFor="let shortcut of hiddenShortcuts" class="shortcut-card"
						[style]="{ backgroundColor: shortcut.backgroundColor, color: shortcut.textColor}"
						[routerLink]="shortcut.routerLink"
						(click)="shortcut.href ? openExternalLink(shortcut.href) : null">
						<div class="shortcut-content">
							<i [class]="shortcut.icon" [style]="{ color: shortcut.textColor }"></i>
							<div class="shortcut-label">{{ shortcut.label }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Empty state -->
		<div class="text-center p-4 border-round surface-card shadow-2 mb-4" *ngIf="shortcuts.length === 0">
			<i class="pi pi-info-circle text-4xl text-600 mb-3"></i>
			<p class="text-xl text-600 mb-3">Aucun raccourci configuré</p>
			<p class="text-600 mb-3">Cliquez sur le bouton de configuration pour ajouter vos raccourcis préférés.</p>
			<button pButton label="Configurer les raccourcis" icon="pi pi-cog" (click)="showShortcutDialog = true"
				class="p-button-raised"></button>
		</div>
	</div>

	<div class="col-12 md:col-6">
		<p-listbox autofocus [options]="emplacements" scrollHeight="45vh" [style]="{width: '100%'}"
			[filter]="true" [filterFields]="['code', 'nom']" filterPlaceHolder="Rechercher..."
			(onClick)="onEmplacementSelect($event)">
			<ng-template let-option pTemplate="item">
				<div class="flex align-items-center gap-2">
					<i class="pi pi-map-marker"></i>
					<div class="flex flex-column">
						<span class="ml-1 font-bold">{{option.code}}</span>
						<span class="ml-1">{{option.nom}}</span>
					</div>
				</div>
			</ng-template>
		</p-listbox>
	</div>

	<!-- Action Shortcuts Card -->
	<div class="col-12 md:col-6">
		<div class="grid pr-0">
			@for (action of actionShortcuts; track action.id) {
			<div class="col-4">
				<p-card *ngIf="action.permission && estAutorise(action.permission)" (click)="executeAction(action)" class="cursor-pointer h-full pr-0" styleClass="h-full">
					<div class="flex flex-column align-items-center justify-content-between">
						<div class="flex align-items-center justify-content-center">
							<i class="pi pi-{{ action.icon }}" class="text-primary text-2xl"></i>
						</div>
						<span class="action-label">{{ action.label }}</span>
					</div>
				</p-card>
			</div>
			}
			<div class="col-12">
				<p-card class="h-full pr-0" styleClass="h-full">
					À venir...
				</p-card>
			</div>
		</div>
	</div>
</div>

<!-- Manage Shortcuts Dialog -->
<p-dialog [(visible)]="showShortcutDialog" header="Gérer les raccourcis" [modal]="true" [style]="{width: '50vw'}"
	[maximizable]="true">
	<div class="grid">
		<div class="col-12">
			<h3>Raccourcis disponibles</h3>
			<div class="grid">
				<div *ngFor="let shortcut of availableShortcuts" class="col-12 md:col-6 lg:col-4">
					<div class="p-card p-3 border-round surface-card shadow-2 mb-3">
						<div class="flex align-items-center justify-content-between">
							<div class="flex align-items-center">
								<i [class]="shortcut.icon" class="mr-2"></i>
								<span>{{shortcut.label}}</span>
							</div>
							<button pButton [icon]="isShortcutActive(shortcut) ? 'pi pi-minus' : 'pi pi-plus'"
								[class]="isShortcutActive(shortcut) ? 'p-button-danger' : 'p-button-success'"
								class="p-button-rounded p-button-sm"
								(click)="isShortcutActive(shortcut) ? onRemoveShortcut(shortcut) : onAddShortcut(shortcut)"
								[pTooltip]="isShortcutActive(shortcut) ? 'Retirer le raccourci' : 'Ajouter le raccourci'">
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</p-dialog>

<!-- Reorder Shortcuts Dialog -->
<p-dialog [(visible)]="showShortcutReorderDialog" header="Réorganiser les raccourcis" [modal]="true"
	[style]="{width: '60vw'}" [maximizable]="true">
	<div class="grid">
		<div class="col-12">
			<p class="text-600 mb-3">Glissez et déposez les raccourcis pour réorganiser leur ordre d'affichage. Les
				raccourcis en haut de la liste apparaîtront en premier.</p>

			<div class="reorder-list" cdkDropList (cdkDropListDropped)="onReorderDrop($event)">
				<div *ngFor="let shortcut of shortcutsForReorder" class="reorder-item" cdkDrag>
					<i class="pi pi-bars drag-handle" cdkDragHandle></i>
					<div class="reorder-item-content">
						<i [class]="shortcut.icon"></i>
						<span class="item-label">{{ shortcut.label }}</span>
					</div>
				</div>
			</div>

			<!-- Empty state for reorder -->
			<div class="text-center p-4" *ngIf="shortcutsForReorder.length === 0">
				<i class="pi pi-info-circle text-3xl text-600 mb-2"></i>
				<p class="text-600">Aucun raccourci à réorganiser. Ajoutez d'abord des raccourcis pour pouvoir les
					réorganiser.</p>
			</div>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<button pButton label="Annuler" icon="pi pi-times" class="p-button-text" (click)="cancelReorder()"></button>
		<button pButton label="Sauvegarder" icon="pi pi-check" class="p-button-raised" (click)="saveReorder()"
			[disabled]="shortcutsForReorder.length === 0"></button>
	</ng-template>
</p-dialog>